import { useQuery } from "@tanstack/react-query"
import { merge } from "lodash"
import { getMovieShowTime } from "./services/getMovieShowTime"
import { IMovieShowTime } from "extensions/movie-show-time/interfaces"

interface IOptions {
  enabled?: boolean
}

type UseMovieShowTime = (
  cinemaCode: string,
  options: IOptions
) => {
  isLoading: boolean
  showtime: IMovieShowTime[]
}

const DEFAULT_OPTION = {
  enabled: true,
}

export const useMovieShowTime: UseMovieShowTime = (cinemaCode, options) => {
  const { enabled }: IOptions = merge(DEFAULT_OPTION, options)
  const { data, isLoading } = useQuery({
    queryKey: ["movie", cinemaCode],
    queryFn: async () => await getMovieShowTime(cinemaCode),
    enabled: enabled,
    // TODO:Implement Stale Time
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  })

  const { showtime = [] } = data || {}

  return { showtime: showtime as IMovieShowTime[], isLoading }
}
